// should be refactored/replaced by new one
// @date 2019-07-08 some modifications regarding jQuery code style and using var
//  @author Mario Sassmann <mario.sassmann@speedy-space.com>
// @TODO: convert appointment filtering to S&F and replace these logic with another

( function( $ ) {

    const body = document.body;
    $( document ).ajaxStart( () => {
        body.classList.add( 'loading' );
    } );

    $( document ).ajaxStop( () => {
        body.classList.remove( 'loading' );
    } );

    //AJAX request
    $( '#events_filter_form' ).submit( ajaxSubmit );

    function ajaxSubmit() {
        //var filterForm = $( this ).serialize();
        const vthema = $( "#thema" ).val();
        const vland = $( "#land" ).val();
        let eventCounter = 0;

        //Message box
        const close = document.getElementsByClassName( "closebtn" );
        for ( let i = 0; i < close.length; i++ ) {
            close[ i ].onclick = () => {
                $.when( $( '.events_msg' ).fadeOut( 600 ) ).done( function () {
                    $( '.event_filter_text' ).remove();
                } );
            }
        }

        $.ajax( {
            action: 'filter_events',
            type: 'POST',
            url: 'event_filter_ajax'.ajax_url,
            data: 'event_filter_ajax'.filterForm,
            success: function () {
                //Delete previous message
                $.when( $( '.events_msg' ).hide() ).done( () => {
                    $( '.event_filter_text' ).remove();
                } );

                $( '.event' ).each( function () {
                    //console.log("Filter: " + vthema + ", " + vland);
                    const tag = $( this ).find( '.tag' ).text();
                    const country = $( this ).find( '.country' ).text();

                    //Event has to match THEMA and LAND
                    if ( vthema !== "Alle Themen" && vland !== "Alle" ) {
                        if ( vthema === tag && vland === country ) {
                            $( this ).fadeIn();
                            eventCounter++;
                        } else
                            $( this ).hide();
                        //Show ALL
                    } else if ( vthema === "Alle Themen" && vland === "Alle" ) {
                        eventCounter++;
                        $( this ).fadeIn();
                        //Event has to match THEMA
                    } else if ( vthema !== "Alle Themen" && vland === "Alle" ) {
                        if ( vthema === tag ) {
                            $( this ).fadeIn();
                            eventCounter++;
                        } else
                            $( this ).hide();
                        //Event has to match LAND
                    } else if ( vthema === "Alle Themen" && vland !== "Alle" ) {
                        if ( vland === country ) {
                            $( this ).fadeIn();
                            eventCounter++;
                        } else
                            $( this ).hide();
                    }
                } );

                //Add success message
                let msg = "";
                let wurdeN = "wurden";
                let TerminE = "Veranstaltungen";
                const land = $( "#land option:selected" ).text();

                if ( eventCounter !== 0 ) {
                    if ( eventCounter === 1 ) {
                        wurdeN = "wurde";
                        TerminE = "Veranstaltung";
                    }

                    if ( vthema !== "Alle Themen" ) {
                        msg += "Es " + wurdeN + " " + eventCounter + " " + TerminE + " zum Thema <i>" + vthema + "</i>";
                        //msg += "Für das Thema <i>" + vthema + "</i> "+wurdeN+" " + eventCounter + " " + TerminE;
                        if ( vland !== "Alle" ) {
                            if ( land === "Schweiz" )
                                msg += " in der <i>" + land + "</i>";
                            else
                                msg += " in <i>" + land + "</i>";
                        }

                    } else if ( vland !== "Alle" ) {
                        if ( land === "Schweiz" )
                            msg += "Es " + wurdeN + " " + eventCounter + " " + TerminE + " in der <i>" + land + "</i>";
                        else
                            msg += "Es " + wurdeN + " " + eventCounter + " " + TerminE + " in <i>" + land + "</i>";
                    }

                    if ( msg !== "" ) {
                        const events_msg_filter_success = $( '.events_msg.filter_success' );
                        events_msg_filter_success.append( $( '<span class="event_filter_text">' +
                            msg + ' gefunden</span>' ) );
                        events_msg_filter_success.fadeIn( 600 );
                    }
                } else {
                    //No search results
                    $( ".vc_toggle" ).hide();

                    if ( vthema !== "Alle Themen" ) {
                        msg += "zum Thema <i>" + vthema + "</i>";
                    }
                    if ( vland !== "Alle" ) {
                        if ( land === "Schweiz" )
                            msg += " in der <i>" + land + "</i>";
                        else
                            msg += " in <i>" + land + "</i>";
                    }

                    const events_msg_filter_warning = $( '.events_msg.filter_warning' );
                    events_msg_filter_warning.append( $( '<span class="event_filter_text">' +
                        'Leider konnten keine Veranstaltungen ' + msg + ' gefunden werden</span>' ) );
                    events_msg_filter_warning.fadeIn( 600 );
                }
            },
            error: () => {
                console.log( errorThrown );
            }
        } ).done( () => {
            hideEmptyMonths();
        } );

        return false;
    }

    function hideEmptyMonths() {
        $( '.vc_toggle' ).each( function () {
            let oneVisible = false;

            $( this ).children( '.vc_toggle_content' ).children( '.event' ).each( function () {
                if ( $( this ).css( 'display' ) !== 'none' ) {
                    oneVisible = true;
                    return false;
                }
            } );

            if ( ! oneVisible ) {
                $( this ).hide();
            } else {
                $( this ).fadeIn( 600 );
            }
        } );
    }

} ) ( jQuery );
